import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkInviteComponent } from './bulk-invite.component';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { CalendarDateComponent } from './components/calendar-date/calendar-date.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { CustomFileInputComponent } from './components/custom-file-input/custom-file-input.component';
import { CsvTableComponent } from './components/csv-table/csv-table.component';
import { MobileTableCardModule } from '../mobile-table-card/mobile-table-card.module';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input-v16';

const components = [
  BulkInviteComponent,
  DateTimePickerComponent,
  CalendarDateComponent,
  CustomFileInputComponent,
];

@NgModule({
  declarations: [...components, CsvTableComponent],
  imports: [
    CommonModule,
    MaterialModule,
    MobileTableCardModule,
    NgxMatIntlTelInputComponent,
  ],
  exports: [CommonModule, ...components],
})
export class BulkInviteModule {}
